// extracted by mini-css-extract-plugin
export var cost = "style-module--cost--11a1a";
export var costNew = "style-module--cost-new--9b4d4";
export var costOld = "style-module--cost-old--3937c";
export var info = "style-module--info--89630";
export var left = "style-module--left--87ada";
export var right = "style-module--right--631a4";
export var wrap = "style-module--wrap--58153";